export const LORAS = {
  REALISM:
    "https://huggingface.co/comfyanonymous/flux_RealismLora_converted_comfyui/blob/main/flux_realism_lora.safetensors",
};
